export interface TechnologyInterface  
    {
        "name": string,
        "logo": string,
    }

export const frontend = () => {
    return [
    {  
        "name": "Vue.js",
        "logo": "vue"
    }, 
    {
        "name": "React",
        "logo": "react"
    },
    {
        "name": "TypeScript",
        "logo": "typescript"
    },
    {
        "id": 125,
        "name": "HTML 5",
        "logo": "html"
    },
    {
        "name": "CSS 3",
        "logo": "css"
    },
    {
        "name": "JavaScript",
        "logo": "javascript"
    },
    {
        "name": "Bootstrap",
        "logo": "bootstrap5"
    },
    {
        "name": "Material UI",
        "logo": "mui"
    }
    
    ]
}


export const backend= ()=>{
    return [
     {
        "name": "Spring",
        "logo": "spring"
    },
    {
        "name": "Spring Boot",
        "logo": "springboot"
    },
       {
        "name": "Json",
        "logo": "json"
    },
       {
        "name": "Node.js",
        "logo": "node"
    },
        {
        "name": "Java",
        "logo": "java"
    },
    {
        "name": "Kotlin",
        "logo": "kotlin"
    }
    ]
}

export const database = ()=>{
    return [
    {
        "name": "Postgresql",
        "logo": "postgresql"
    },
    {
        "name": "SQL",
        "logo": "sql"
    }
    ]
}

export const devops = ()=>{
    return [
    {
        "name": "Digital Ocean",
        "logo": "digitalocean"
    },
    {
        "name": "Openshift",
        "logo": "openshift"
    },
         {
            "name": "Github",
            "logo": "github"
        },
        {
            "name": "GitLabs",
            "logo": "gitlab"
        },
         {
            "name": "bitbucket",
            "logo": "bitbucket"
        },
         {
            "name": "Teamcity",
            "logo": "teamcity"
        },
         {
            "name": "SonarQube",
            "logo": "sonarqube"
        }
    ]
}

export const other = ()=>{
    return [
        {
            "name": "Cricut",
            "logo": "cricut"
        },
         {
            "name": "Game Maker",
            "logo": "gamemaker"
        },
         {
            "name": "Figma",
            "logo": "figma"
        },
         {
            "name": "Procreate",
            "logo": "procreate"
        }
    ]
}


